import { initAcrawler } from '../../utils/acrawler';
import BaseInterface from '../base/index';
import { TypeVerify, TypeLogin, TypeBind } from '../../types/app';
import VerifyAPI from './verify';
import LoginAPI from './login';
import BindAPI from './bind';

import { TypeInitProps } from '../../types/index';
export default class AppInterface extends BaseInterface {
  public verify: TypeVerify;
  public login: TypeLogin;
  public bind: TypeBind;

  constructor(props: TypeInitProps) {
    super(props, 'app');
    const { printLog = false, acrawler = '' } = props;
    // log
    if (printLog) {
      console.log('AppInterface Initial Props >>>>', props);
    }
    // acrawler
    if (acrawler) {
      initAcrawler(acrawler, props);
    }

    // web interfaces
    let argus = { ...props, request: this.request };
    this.verify = new VerifyAPI(argus);
    this.login = new LoginAPI(argus);
    this.bind = new BindAPI(argus);
  }
}
